<template>
  <div>
    <div class="row mb-5">
      <div class="col-12" style="display: flex; align-items: center">
        <span class="display-4">
          {{ `${establishment.company_name}` }} -
          {{ $t("COMMON.SALES_ORDERS") }}
        </span>
        <base-button
          v-if="establishment.active"
          type="primary"
          icon
          size="sm"
          @click="
            () => {
              showAddSalesOrderModal = true;
            }
          "
        >
          <span class="btn-inner--icon">
            <i class="ni ni-single-copy-04"></i>
            {{ $t("ESTABLISHMENTS.ADD_SALES_ORDER") }}
          </span>
        </base-button>
        <base-button
          v-if="
            establishment.active &&
            $currentUserCan($permissions.PERM_CREATE_SALES_ORDERS) &&
            $currentUserCan($permissions.PERM_CREATE_COUPONS_SALES_ORDERS)
          "
          type="secondary"
          icon
          size="sm"
          @click="
            () => {
              showAddCouponsSalesOrderModal = true;
            }
          "
        >
          <span class="btn-inner--icon">
            <i class="ni ni-tag"></i>
            {{ $t("SALES_ORDERS.ADD_COUPONS_SALES_ORDER") }}
          </span>
        </base-button>
        <help-button context="sales-orders" class="ml-2" />
      </div>
    </div>

    <sales-order-list-table
      v-if="establishment.id"
      :filterEstablishment="establishment.id"
      :hideUpdateAndDelete="true"
    />

    <estbalishment-view-sales-orders-add-sales-order-modal
      :establishment="establishment"
      :showModal="showAddSalesOrderModal"
      @onCloseModal="
        () => {
          showAddSalesOrderModal = false;
        }
      "
    />

    <establishment-view-sales-orders-add-coupons-sales-order-modal
      :establishment="establishment"
      :showModal="showAddCouponsSalesOrderModal"
      @onCloseModal="
        () => {
          showAddCouponsSalesOrderModal = false;
        }
      "
    />
  </div>
</template>

<script>
import SalesOrderListTable from "../../../SalesModule/SalesOrderManagement/partials/SalesOrderListTable.vue";
import EstbalishmentViewSalesOrdersAddSalesOrderModal from "./EstbalishmentViewSalesOrdersAddSalesOrderModal.vue";
import EstablishmentViewSalesOrdersAddCouponsSalesOrderModal from "./EstablishmentViewSalesOrdersAddCouponsSalesOrderModal.vue";

export default {
  name: "establishment-view-orders",

  components: {
    SalesOrderListTable,
    EstbalishmentViewSalesOrdersAddSalesOrderModal,
    EstablishmentViewSalesOrdersAddCouponsSalesOrderModal,
  },

  props: ["establishment"],

  data() {
    return {
      showAddSalesOrderModal: false,
      showAddCouponsSalesOrderModal: false,
    };
  },

  computed: {},

  created() {},

  methods: {},

  mounted() {},

  watch: {
    establishment(establishment) {},
  },
};
</script>
